<template>
<div id="main" style="position: relative; overflow: hidden">
    <div id="list" class="show">
        <!-- header -->
        <header>
            会員検索
            <div class="h-left">
                <a @click="isLoading = true; filterUser({})"><img src="~@/assets/images/icon04.svg" /></a>
            </div>
            <div class="h-right">
                <a @click="openSearchForm"><img src="~@/assets/images/icon03.svg" /></a>
            </div>
        </header>
        <div id="wrap3">
            <header class="menu">
            <ul id="header" class="h-menu3 clearfix">
                <li class="item active-item" data-type="0">全ての会員</li>
                <!-- <li v-else @click="type = 0; filterUser(formData)" class="menu-item">全ての会員</li> -->
                <!--  -->
                <li class="item menu-item" data-type="1">新規会員</li>
                <!-- <li v-else @click="type = 1; filterUser(formData)" class="menu-item">新規会員</li> -->
                <!--  -->
                <li class="item menu-item" data-type="11">会える待ち</li>
                 <!-- <li v-else @click="type = 11; filterUser(formData)" class="menu-item">会える待ち</li> -->
                <!--  -->
                <li class="item menu-item" data-type="12">音声通話待ち</li>
                <!-- <li v-else @click="type = 12; filterUser(formData)" class="menu-item">音声通話待ち</li> -->
                <!--  -->
                <li class="item menu-item" data-type="13">ビデオ通話待ち</li>
                 <!-- <li v-else @click="type = 13; filterUser(formData)" class="menu-item">ビデオ通話待ち</li> -->
            </ul>
            </header>
        </div>
        <div style="height: 100%;">
            <ul class="search01 clearfix" id="wrap" style="margin-top: 0px; padding-bottom: 0">
                <li v-for="(item, index) in users" :key="index">
                    <div class="area">
                        <a @click="redirectUserDetail(item.id, index)">
                            <img v-if="item.avatar_show" :src="getImageUrl(item.avatar_url)" />
                            <span v-else>No avatar</span>
                            <!-- <div class="blurC" v-if="parseInt(item.is_new) === IS_NEW ">NEW</div> -->
                            <div v-if="parseInt(item.is_new) === IS_NEW " class="new-label">
                                <span class="new-label-text">NEW&nbsp;</span>
                            </div>
                        </a>
                        <p class="fav">
                            <i :class="
                      item.is_like === IS_LIKE ? 'fas fa-heart red heart-'+index : 'fas fa-heart heart-'+index
                    " @click="likeUser(item.id, item.is_like, index)"></i>
                        </p>
                        <p :class="parseInt(item.online) == IS_ONLINE ? 'p-login' : 'p-logoff'"></p>
                        <p class="s-prof">
                            {{ getLiving(item.living_area_id) }} {{ item.age }}歳
                        </p>
                    </div>
                    <p style="min-height: 24px;">{{ item.mood_status_tmp }}</p>
                </li>
            </ul>
            <infinite-loading style="margin-bottom: 66px" @infinite="scrollGetUser" spinner="spiral" :identifier="infiniteId">
                <template v-slot:no-more></template>
                <template v-slot:no-results>
                    <div id="middle">検索結果0件です</div>
                </template>
            </infinite-loading>
        </div>
        <div class="loading-screen" v-if="isLoading">
            <div class="loader"></div>
        </div>
    </div>
    <div id="search" class="hidden-right">
        <search  @close="saveDataSearch" :dataSearch="dataSearch" />
    </div>
</div>
<div id="detail" class="hidden-detail" >
    <detail v-if="isShowDetail" :idUser="idUser" @close="closeDetail"></detail>
</div>

</template>

<script>
import CONSTANTS from "@/constants";
import {
    mapActions,
    mapGetters
} from "vuex";
import search from "./components/search"
import detail from "./detail"
import mixin from "@/mixin"

export default {
    name: "user",
    components: {
        search,
        detail
    },
    mixins: [mixin],
    data: () => ({
        users: [],
        pageSize: 30,
        pageCurrent: 1,
        formData: {},
        IS_LIKE: CONSTANTS.IS_LIKE,
        IS_FAVORITE: CONSTANTS.IS_FAVORITE,
        IS_ONLINE: CONSTANTS.IS_ONLINE,
        NO_ONLINE: CONSTANTS.IS_ONLINE,
        NOT_VALUE: CONSTANTS.NOT_VALUE,
        IS_NEW: CONSTANTS.IS_NEW,
        isSearch: false,
        type: 0,
        noResult: false,
        message: "",
        loading: false,
        isGet: true,
        infiniteId: +new Date(),
        dataSearch: null,
        isLoading: true,
        isShowDetail: false,
        idUser: null,
        heartindex: null,
        scrollHeight: null,
    }),
    computed: {
        ...mapGetters(["metadata", 'defaultToken', "pointSetting", "userDetail"]),

    },
    async mounted() {
        this.setFooter(true)
        if (!this.userDetail) {
            await this.userProfile({
                token: this.defaultToken
            })
        }
        this.eventActiveMenu()
        this.scrollMenu()
    },
    watch: {
        type(newValue) {
            this.users = []
            this.pageCurrent = 1
        },
        isShowDetail(val) {
            const body = document.getElementsByTagName('body')[0];
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        },
        isSearch(val) {
            const body = document.getElementsByTagName('body')[0];
            if (val) body.style.overflow = "hidden";
            else body.style.overflow = "auto";
        }
    },
    sockets: {},
    methods: {
        ...mapActions({
            setFooter: 'layout/setFooter',
            userProfile: 'user/userProfile'
        }),
        closeDetail(likeStatus) {
            document.getElementById('main').style.display = "unset"
            this.setFooter(true)
            document.getElementById('detail').classList.remove('show-detail')
            document.getElementById('detail').classList.add('hidden-detail')
            setTimeout(() => {
                if (likeStatus) {
                    document.getElementsByClassName('heart-' + this.heartindex)[0].classList.add("red");
                }
                this.isShowDetail = false
                 window.scrollTo(0, this.scrollHeight);
            }, 1)
        },
        redirectUserDetail(id, index) {
            this.scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            document.getElementById('main').style.display = "none"
            this.isShowDetail = true
            document.getElementById('detail').classList.remove('hidden-detail')
            document.getElementById('detail').classList.add('show-detail')
            this.setFooter(false)
            this.idUser = id.toString()
            this.heartindex = index
        },
        saveDataSearch(data) {
            document.getElementById('search').classList.add('hidden-right')
            document.getElementById('search').classList.remove('show-right')
            this.isSearch = false
            document.getElementById('list').classList.remove('hidden')
            document.getElementById('list').classList.add('show')
            document.getElementById('header').classList.remove('hidden')
            // document.getElementById('header').classList.add('show')

            this.dataSearch = data
        },
        openSearchForm() {
            // Fix cannot search on safari
            document.querySelector('#main-search #wrap').style = 'height: ' + window.innerHeight + 'px; ' + 'overflow-y: scroll;';
            document.getElementById('search').classList.remove('hidden-right')
            document.getElementById('search').classList.add('show-right')
            this.isSearch = true
            document.getElementById('list').classList.remove('show')
            document.getElementById('list').classList.add('hidden')
            document.getElementById('header').classList.remove('show')
            document.getElementById('header').classList.add('hidden')
            this.setFooter(false)
        },
        setDataSearch(formData) {
            let asArray = Object.entries(formData);
            this.formData = asArray.filter(item => {
                return item[1] !== 999 && item[1] !== null && item[1] !== ''
            })
            this.formData = Object.fromEntries(this.formData)
        },
        filterUser(formData) {
            this.pageCurrent = 1
            this.users = []
            this.formData = Object.assign(formData, {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
                type: this.type,
                action: 'search'
            })
            this.infiniteId++
        },
        search(formData) {
            this.isSearch = false
            this.filterUser(formData)
        },
        async scrollGetUser($state) {
            // if (this.users.length > 0 && this.users.length < this.pageSize) {
            //     $state.complete();
            //     return;
            // } else {
            //     console.log(this.users.length)
            // }
            this.formData = Object.assign(this.formData, {
                page: this.pageCurrent,
                limit: this.pageSize,
                token: this.defaultToken,
                type: this.type,
                action: 'search'
            })
            this.setDataSearch(this.formData)
            await this.$store.dispatch("user/userFind", this.formData).then((data) => {
                if (data.result.length > 0) {
                    this.users.push(...data.result)
                    this.pageCurrent++
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }).catch(async (err) => {
                // console.log('error:', err);
                this.filterUser({});
            });
            this.isLoading = false
        },
        getLiving(id) {
            if (!this.metadata) return
            let living = this.metadata.user_profile_list.living_area.filter(
                (item) => {
                    return item.field_id === id;
                }
            );
            if (living[0]) {
                return living[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        getIncome(id) {
            if (!this.metadata) return
            let income = this.metadata.user_profile_list.income.filter((item) => {
                return item.field_id === id;
            });
            if (income[0]) {
                return income[0].name;
            }
            return CONSTANTS.NOT_VALUE;
        },
        likeUser(id, isLike, index) {
            if (isLike !== CONSTANTS.IS_LIKE) {
                let formData = new FormData();
                formData.append("type", 0);
                formData.append("token", this.defaultToken);
                formData.append("user_like_id", id);

                this.$store
                    .dispatch("user/likeUser", formData)
                    .then(() => {
                        document.getElementsByClassName('heart-' + index)[0].classList.add("red");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }

        },
        scrollMenu() {
            let scrollTo = 0
            document.body.addEventListener('click', function (evt) {
                let activeItem = document.getElementsByClassName('active-item')[0]
                if (evt.target.classList.contains('menu-item')) {
                    let selectedItem = evt.target
                    activeItem.classList.remove('active-item');
                    activeItem.classList.add('menu-item');
                    selectedItem.classList.add('active-item');
                    selectedItem.classList.remove("menu-item")
                    let parent = document.getElementsByClassName('h-menu3')[0]
                    let activeIndex = Array.prototype.indexOf.call(parent.children, activeItem);
                    let selectedIndex = Array.prototype.indexOf.call(parent.children, selectedItem);
                    if (selectedIndex > activeIndex) {
                        scrollTo =  selectedItem.offsetLeft - activeItem.offsetLeft;
                    } else {
                        scrollTo =  selectedItem.offsetLeft - activeItem.offsetLeft
                        // if (scrollTo >= 0) {
                        //     scrollTo = 0;
                        // }
                    }
                    parent.scrollBy({
                        left: scrollTo,
                        behavior: 'smooth'
                    })
                } else {
                }
            }, false);
        },
        eventActiveMenu() {
            let menuItems = document.getElementsByClassName('item')

            for(let i = 0; i < menuItems.length; i ++) {
                menuItems[i].addEventListener('click', (e) => {
                    if (parseInt(e.target.getAttribute('data-type') === this.type)) {
                        return
                    }
                    this.isLoading = true
                    this.type = parseInt( e.target.getAttribute('data-type'))
                    this.filterUser(this.formData)
                })
            }
        }
    },
};
</script>

<style scoped>
.blurC {
    position: absolute;
    top: 0;
    /* bottom: 0; */
    left: -48px;
    /* right: 0; */
    background: #565656a1;
    color: #ffff;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: rotateZ(-45deg);
    width: 100%;
    background: #fb7418;
    font-size: 10px;
}

.new-label {
    position: absolute;
    top: 0;
    left: 0;
    border-width: 0 0 40px 40px;
    border-style: solid;
    border-color: transparent #ff126d;
    opacity: 0.85;
    color: white;
}

.new-label-text {
    position: absolute;
    font-weight: bold;
    font-size: 11px;
    transform: rotateZ(-45deg);
    top: 4px;
    right: 12px;
}

.area {
    overflow: hidden;
    border-top-left-radius: 8px;
}
/*  */

.menu-item {
    color: #898989;
    font-weight:100
}
.search01 {
    padding-bottom: 100px;
}
#list {
    transition: all 0.2s;
    min-height: 100vh;
}
#header {
    transition: all 0.2s;
}
 #search {
    transition: right 0.2s;
}
.hidden {
    width: 0;
    opacity: 0;
    overflow: hidden;
}
.show {
    width: 100%;
    opacity: 1;
    overflow: unset;
}
.hidden-right {
    position: fixed;
    right: -100%;
    top: 0;
    width: 100%;
    opacity: 0;
    overflow: hidden;
}
.show-right {
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    opacity: 1;
    overflow: hidden;
}

.hidden-detail {
    opacity: 0;
    height: 0px;
    width: 0px;
    transform: scale(0,0);
    overflow: hidden;

}
.show-detail {
    opacity: 1;
    transform: scale(1,1);
    height: 100%;
    width: 100%;
    overflow: unset;
}
#detail {
    transition: all 0.2s;
    position: fixed;
    right: 0;
}
.h-menu3 {
    position: unset;
}
#wrap3 {
    max-width: unset;
}
.menu {
    top: 42px;
}
</style>
